var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-quick-action-button',{attrs:{"title":"Hapus","icon":"trash","disabled":_vm.disabled,"color":"danger"},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }